// extracted by mini-css-extract-plugin
module.exports = {"modal":"DemoModal_modal__3TGAx","underlay":"DemoModal_underlay__1pdyH","content":"DemoModal_content__a8BCA"};